import moment from "moment";
import type { IOTPAuthStatusResponse } from "../interfaces";

class OTPAuthenticator {
	public static EmptyConstructorParams: IOTPAuthStatusResponse = {
		otpExpiry: null,
		isAuthed: false,
	};

	public static ConstructEmpty(): OTPAuthenticator {
		return OTPAuthenticator.Construct(
			OTPAuthenticator.EmptyConstructorParams,
			[],
		);
	}

	public static Construct(
		otpAuthStatus: IOTPAuthStatusResponse,
		otpRestrictedRoutes: Array<string>,
	): OTPAuthenticator {
		return new OTPAuthenticator(otpAuthStatus, otpRestrictedRoutes);
	}

	private otpAuthStatus: IOTPAuthStatusResponse;

	private otpRestrictedRoutes: Array<string> = [];

	constructor(
		otpAuthStatus: IOTPAuthStatusResponse,
		otpRestrictedRoutes: Array<string> = [],
	) {
		this.otpAuthStatus = otpAuthStatus;
		this.otpRestrictedRoutes = otpRestrictedRoutes;
	}

	isAuthenticated(): boolean {
		const { otpExpiry } = this.otpAuthStatus;

		if (!otpExpiry) {
			return false;
		}

		const hasExpired = moment().diff(moment(otpExpiry)) > 0;
		return !hasExpired;
	}

	isRestrictedRoute(routeName: string): boolean {
		const isRestrictedRoute = this.otpRestrictedRoutes.find(
			(rN) => rN === routeName,
		);

		return !!isRestrictedRoute;
	}

	shouldBlock(routeName: string): boolean {
		if (this.isRestrictedRoute(routeName)) {
			return !this.isAuthenticated();
		}

		return false;
	}

	isNavigationStateAllowed(currentRouteName: string): boolean {
		if (this.isRestrictedRoute(currentRouteName) && !this.isAuthenticated()) {
			return false;
		}

		return true;
	}

	set(otpAuthStatus: IOTPAuthStatusResponse): void {
		this.otpAuthStatus = otpAuthStatus;
	}

	clear(): void {
		this.otpAuthStatus = OTPAuthenticator.EmptyConstructorParams;
	}
}

export default OTPAuthenticator;
